import primer from "../primer"

export default (getView) => (nextStepPath, externalCheckoutPath) => ({
  ...getView(nextStepPath),
  ...primer(),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    const externalCheckout = pipelineConfig.variant.includes("External-Checkout")

    if (!externalCheckout) {
      this.addConfirmationEventListener()
      this.initPrimer({
        checkoutCompletePath: nextStepPath,
      })
    }
  },

  goToExternalPaymode(hideApm = false) {
    this.store.values.hideApm = hideApm
    window.location = this.store.addTokenHashParam(externalCheckoutPath)
  },
})
